const RETURN_PATH_KEY = "matematron.maturaDemo.returnPath.v1";
const DEFAULT_MATURA_SHEET_ID = "cke-p-2025-maj";

function sanitizeDemoPath(value) {
  const path = String(value || "");
  if (!path.startsWith("/demo/matura") && !path.startsWith("/demo/arkusz-maturalny")) return "";
  return path.slice(0, 2000);
}

export function rememberDemoMaturaReturnPath() {
  if (typeof window === "undefined") return "";
  const path = sanitizeDemoPath(
    `${window.location.pathname}${window.location.search}${window.location.hash}`
  );
  if (!path) return "";
  try {
    window.localStorage.setItem(RETURN_PATH_KEY, path);
  } catch {}
  return path;
}

export function consumeDemoMaturaReturnPath() {
  if (typeof window === "undefined") return "";
  try {
    const stored = sanitizeDemoPath(window.localStorage.getItem(RETURN_PATH_KEY));
    window.localStorage.removeItem(RETURN_PATH_KEY);
    if (!stored) return "";
    const url = new URL(stored, window.location.origin);
    url.searchParams.delete("adminPreview");
    url.searchParams.delete("publicPreview");
    if (url.pathname.startsWith("/demo/matura/sciezka")) {
      url.pathname = url.pathname.replace("/demo/matura/sciezka", "/matura/sciezka");
      return `${url.pathname}${url.search}${url.hash}`;
    }
    if (url.pathname.startsWith("/demo/matura-exam/")) {
      url.pathname = url.pathname.replace("/demo/matura-exam/", "/matura-exam/");
      return `${url.pathname}${url.search}${url.hash}`;
    }
    if (url.pathname === "/demo/arkusz-maturalny") {
      const sheetId = url.searchParams.get("sheet") || DEFAULT_MATURA_SHEET_ID;
      return `/matura/arkusze/${encodeURIComponent(sheetId)}`;
    }
    return "";
  } catch {
    return "";
  }
}

export const demoMaturaReturnPathStorageKey = RETURN_PATH_KEY;
